module.exports = __webpack_public_path__ + "static/media/detail3_xray_pg3.b62382e7.png";